import type { PublicClientApplication } from '@azure/msal-browser';
import { apiRequest } from './msal-config';

let runtimeMsalInstance: PublicClientApplication | null = null;

export function setRuntimeMsalInstance(instance: PublicClientApplication): void {
  runtimeMsalInstance = instance;
}

export async function getRuntimeAccessToken(): Promise<string | null> {
  if (!runtimeMsalInstance) return null;

  const activeAccount = runtimeMsalInstance.getActiveAccount();
  const fallbackAccount = runtimeMsalInstance.getAllAccounts()[0] ?? null;
  const account = activeAccount ?? fallbackAccount;
  if (!account) return null;

  try {
    const response = await runtimeMsalInstance.acquireTokenSilent({
      ...apiRequest,
      account,
    });
    return response.accessToken;
  } catch {
    return null;
  }
}

/**
 * Build a Headers object pre-populated with the MSAL Bearer token (if available).
 *
 * Use for any fetch to `/api/dotnet/*` or `/api/python/*`. The Python backend's
 * `build_user_context` dependency (DevPlan 0103.04) returns 401 without the
 * `X-Sopho-User-Id` header that the .NET reverse proxy only sets when the
 * incoming request carries a valid Bearer token.
 */
export async function withAuthHeaders(init: HeadersInit = {}): Promise<Headers> {
  const headers = new Headers(init);
  const token = await getRuntimeAccessToken();
  if (token) headers.set('Authorization', `Bearer ${token}`);
  return headers;
}